import { render, staticRenderFns } from "./PublicLiabilityComponent.vue?vue&type=template&id=beaa6152&scoped=true&"
import script from "./PublicLiabilityComponent.vue?vue&type=script&lang=js&"
export * from "./PublicLiabilityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa6152",
  null
  
)

export default component.exports